import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { TaskpanelService } from "../../service/taskpanel.service";

/**
 * Global drawer that hosts the REAL Case Management board
 * ({@link TaskManagementWfComponent}) in a right slide-in, so the exact same
 * board renders both on the Case Management page and here — opened from anywhere
 * (e.g. the patient grid's "Cases" action) via `TaskpanelService.openCaseSidebar`.
 *
 * The board mounts only while the drawer is open (`*ngIf`), and it loads its own
 * data through the shared TaskMgmtService (cached across instances), so this host
 * stays a thin shell — it owns no board data or logic.
 */
@Component({
    selector: "app-global-case-sidebar",
    templateUrl: "./global-case-sidebar.component.html",
    styleUrls: ["./global-case-sidebar.component.scss"],
    standalone: false
})
export class GlobalCaseSidebarComponent implements OnInit, OnDestroy {
  isOpen = false;

  /** Tag filter forwarded to the embedded board so it loads only the cases for
   *  the entity the sidebar was opened for (patient/HCP). `tag_name` is the
   *  display label used when the board pre-fills the Create-Case dialog. */
  tagContext: { tag_id: any; tag_category_id: any; tag_name?: any } | null = null;

  private subs: Subscription[] = [];

  constructor(private taskPanelService: TaskpanelService) {}

  ngOnInit(): void {
    this.subs.push(
      this.taskPanelService.openCaseSidebar$.subscribe((ctx: any) => this.open(ctx))
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  open(ctx?: { tag_id: any; tag_category_id: any; tag_name?: any } | null): void {
    this.tagContext = ctx && ctx.tag_id != null ? ctx : null;
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }
}
